/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {RightModel} from "../../user/right.model";

export class AdditionalRightModel{
  readonly: boolean | undefined = undefined;
  active: boolean | undefined = undefined;
  right: RightModel | undefined = undefined;

  constructor(right: RightModel, readonly = false, active = true) {
    this.right = right;
    this.readonly = readonly;
    this.active = active;
  }
}
